function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { NavLink } from 'react-router';
import IconRelease from '~icons/fluent-mdl2/release-definition';
import { ArcAdminLogo } from '@arc/frontend/ui-assets';
import { APP_HEADER_HEIGHT } from '@arc/frontend/ui-layout';
import { theme } from '@arc/frontend/ui-theme';
import { GearMenu } from './GearMenu';
import { HeaderItems } from './HeaderItems';
import { UserMenu } from './UserMenu';
const styles = {
  header: /*#__PURE__*/css({
    backgroundColor: theme.colors.background.header,
    display: 'flex',
    height: APP_HEADER_HEIGHT,
    borderBottom: `1px solid ${theme.colors.background.headerBorder}`,
    color: theme.colors.background.paper
  }, process.env.NODE_ENV === "production" ? "" : ";label:header;"),
  headerLogoContainer: process.env.NODE_ENV === "production" ? {
    name: "171ub07",
    styles: "padding-left:1rem;padding-right:1rem;padding-top:0.5rem;padding-bottom:0.5rem"
  } : {
    name: "1ada0zb-headerLogoContainer",
    styles: "padding-left:1rem;padding-right:1rem;padding-top:0.5rem;padding-bottom:0.5rem;label:headerLogoContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  headerRight: process.env.NODE_ENV === "production" ? {
    name: "1h63efc",
    styles: "display:flex;align-items:stretch"
  } : {
    name: "1fa7hkz-headerRight",
    styles: "display:flex;align-items:stretch;label:headerRight;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  iconButton: process.env.NODE_ENV === "production" ? {
    name: "1k9y3pq",
    styles: "padding-left:0.75rem;padding-right:0.75rem;display:flex;align-items:center"
  } : {
    name: "1pi9fu5-iconButton",
    styles: "padding-left:0.75rem;padding-right:0.75rem;display:flex;align-items:center;label:iconButton;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "18mxbui",
  styles: "width:1em;height:1em"
} : {
  name: "lii8d3-Header",
  styles: "width:1em;height:1em;label:Header;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function Header(props) {
  return <header css={[styles.header, props.outerStyle, process.env.NODE_ENV === "production" ? "" : ";label:Header;"]}>
			<NavLink to="/" end css={styles.headerLogoContainer}>
				<ArcAdminLogo height="42" width="73" title="ARC Admin" />
			</NavLink>
			<HeaderItems iconButtonStyle={styles.iconButton} />
			<div css={styles.headerRight}>
				<NavLink to="/releases" css={styles.iconButton}>
					<IconRelease css={_ref} />
				</NavLink>
				<GearMenu iconButtonStyle={styles.iconButton} />
				<UserMenu />
			</div>
		</header>;
}